import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useModal } from "src/hooks/useModal";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as DeleteIcon } from "src/assets/icons/trash.svg";
import { ReactComponent as PauseIcon } from "src/assets/icons/pause.svg";
import { ReactComponent as CheckIcon } from "src/assets/icons/restore.svg";
import { ReactComponent as EditIcon } from "src/assets/icons/edit.svg";
import { actionButtonsModalTrns, actionButtonsTrns } from "./trns";
import { ConfirmationPopupV2 } from "../ConfirmationPopupV2";

const DEFAULT_BUTTON_CLASSNAME =
  "flex items-center justify-center gap-2 w-full h-10 px-5 py-2 text-lg font-semibold";

interface Props {
  isLoadingPause: boolean;
  isPaused: boolean;
  onDelete: VoidFunction;
  onPause: VoidFunction;
  onRestore: VoidFunction;
  onEdit: VoidFunction;
}

export const ActionButtons: FC<Props> = ({
  isLoadingPause,
  isPaused,
  onDelete,
  onPause,
  onRestore,
  onEdit,
}) => {
  const { t } = useTranslation();
  const confirmationDeletePopup = useModal(false);

  return (
    <div className="flex flex-col md:flex-row items-center gap-3">
      <ConfirmationPopupV2
        {...confirmationDeletePopup}
        description={t(actionButtonsModalTrns.deleteModalDesc)}
        onConfirm={onDelete}
      />
      <Button
        className={DEFAULT_BUTTON_CLASSNAME}
        variant={ButtonVariants.SECONDARY}
        onClick={confirmationDeletePopup.openModal}
      >
        <DeleteIcon />
        <span>{t(actionButtonsTrns.deleteButton)}</span>
      </Button>
      {isPaused ? (
        <Button
          className={DEFAULT_BUTTON_CLASSNAME}
          variant={ButtonVariants.PRIMARY}
          isLoading={isLoadingPause}
          onClick={onRestore}
        >
          <CheckIcon />
          <span>{t(actionButtonsTrns.restoreButton)}</span>
        </Button>
      ) : (
        <Button
          className={DEFAULT_BUTTON_CLASSNAME}
          variant={ButtonVariants.SECONDARY}
          isLoading={isLoadingPause}
          onClick={onPause}
        >
          <PauseIcon />
          <span>{t(actionButtonsTrns.pauseButton)}</span>
        </Button>
      )}

      <Button
        className={DEFAULT_BUTTON_CLASSNAME}
        variant={ButtonVariants.SECONDARY}
        onClick={onEdit}
      >
        <EditIcon />
        <span>{t(actionButtonsTrns.editButton)}</span>
      </Button>
    </div>
  );
};
